export enum MasterDataStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export class MasterData {
  id: string;
  name: string;
  type: string;
  status?: MasterDataStatus;
  createdAt?: number;
  createdBy?: string;
  updatedAt?: number;
  updatedBy?: string;
  [key: string]: any;
}

// export enum MasterDataType {
//   Sector = 'Sector',
//   CreditCardNetwork = 'Credit Card Network',
// }

export enum MasterDataType {
  COLLECTION_TYPE = 'CollectionType',
  STATE = 'State',
  ZONES = 'Zone',
  COUNCILS = 'Council',
  SUBURBS = 'Suburb',
  AREAS = 'Area',
  SYSTEM_ADMIN = 'SystemAdmin',
}
